export const STATUS_ACTIONS_FORM = {
    CREATE: "create",
    MODIFY: "modify"
}